<template>
  <v-dialog
      v-model="dialogInterno"
      :max-width="isMobile ? '100vw' : '900px'"
      :fullscreen="isMobile"
      scrollable
  >
    <v-card v-if="normativa" class="visualization-dialog">
      <!-- Cabeçalho -->
      <v-card-title class="dialog-header" :class="isMobile ? 'pa-3' : 'pa-4'">
        <div class="d-flex align-center flex-grow-1" style="min-width: 0;">
          <div class="icon-wrapper-large" :class="isMobile ? 'mr-2' : 'mr-4'">
            <v-icon :size="isMobile ? 28 : 36" color="white">mdi-file-document</v-icon>
          </div>
          <div class="flex-grow-1" style="min-width: 0;">
            <div class="header-title text-truncate">{{ normativa.titulo }}</div>
            <div v-if="!isMobile" class="header-subtitle">
              <v-chip x-small dark color="rgba(255, 255, 255, 0.2)" class="mr-2">
                Código: {{ normativa.codigo }}
              </v-chip>
              <v-chip
                  x-small
                  :color="normativa.ativo === 'T' ? 'success' : 'grey'"
                  dark
              >
                {{ normativa.ativo === 'T' ? 'Ativa' : 'Inativa' }}
              </v-chip>
            </div>
            <div v-else class="header-subtitle-mobile mt-1">
              <v-chip x-small dark color="rgba(255, 255, 255, 0.2)">
                {{ normativa.codigo }}
              </v-chip>
            </div>
          </div>
        </div>
        <v-btn
            icon
            color="white"
            @click="fechar"
            :small="isMobile"
            class="flex-shrink-0 ml-2"
        >
          <v-icon :size="isMobile ? 20 : 24">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Conteúdo -->
      <v-card-text class="pa-0 dialog-content">

        <!-- Arquivo Principal (sempre expandido) -->
        <v-expansion-panels
            v-model="painelArquivo"
            flat
            accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="section-header-inline" :class="isMobile ? 'pa-3' : 'pa-4'">
              <div class="d-flex align-center">
                <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-file-pdf-box</v-icon>
                <span class="section-title-inline">Arquivo Principal</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card
                  outlined
                  hover
                  @click="handleArquivoPrincipalClick"
                  class="file-card cursor-pointer"
                  :class="isMobile ? 'ma-2' : 'ma-4'"
              >
                <v-card-text class="d-flex align-center" :class="isMobile ? 'pa-2' : 'pa-3'">
                  <div class="file-icon-wrapper" :class="isMobile ? 'mr-2' : 'mr-4'">
                    <v-icon color="red" :size="isMobile ? 32 : 40">mdi-file-pdf-box</v-icon>
                  </div>
                  <div class="flex-grow-1" style="min-width: 0;">
                    <div class="file-name text-truncate">{{ normativa.arquivo_nome }}</div>
                    <div class="file-type">
                      <span v-if="!isMobile">PDF Principal</span>
                      <v-chip x-small color="#e3f2fd" text-color="#1565c0" :class="isMobile ? '' : 'ml-2'">
                        <v-icon left x-small>mdi-eye</v-icon>
                        {{ isMobile ? 'Ver' : 'Clique para visualizar' }}
                      </v-chip>
                    </div>
                  </div>
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          :small="isMobile"
                          color="#023449"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                          class="flex-shrink-0"
                      >
                        <v-icon :size="isMobile ? 20 : 24">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="visualizarArquivoPrincipal">
                        <v-list-item-icon>
                          <v-icon small color="primary">mdi-eye</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Visualizar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="downloadArquivoPrincipal">
                        <v-list-item-icon>
                          <v-icon small color="success">mdi-download</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Download</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider></v-divider>

        <!-- Anexos (sempre expandido se houver) -->
        <v-expansion-panels
            v-if="normativa.anexos && normativa.anexos.length > 0"
            v-model="painelAnexos"
            flat
            accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="section-header-inline" :class="isMobile ? 'pa-3' : 'pa-4'">
              <div class="d-flex align-center">
                <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-paperclip</v-icon>
                <span class="section-title-inline">Anexos</span>
                <v-chip x-small color="#e8f5e9" text-color="#2e7d32" class="ml-2">
                  <v-icon left x-small color="#2e7d32">mdi-paperclip</v-icon>
                  {{ normativa.anexos.length }}
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list class="py-0">
                <v-list-item
                    v-for="(anexo, index) in normativa.anexos"
                    :key="anexo.id || index"
                    class="anexo-item"
                    :class="isMobile ? 'px-2' : ''"
                    @click="handleAnexoClick(anexo)"
                >
                  <v-list-item-avatar :size="isMobile ? 36 : 40">
                    <div class="file-icon-wrapper-small">
                      <v-icon :color="getCorTipo(anexo.arquivo_tipo)" :size="isMobile ? 24 : 28">
                        {{ getIconeTipo(anexo.arquivo_tipo) }}
                      </v-icon>
                    </div>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="anexo-title">
                      <v-chip x-small color="#023449" dark class="mr-1">
                        {{ isMobile ? anexo.identificador : `Anexo ${anexo.identificador}` }}
                      </v-chip>
                      <span class="text-truncate d-inline-block" style="max-width: calc(100% - 60px); vertical-align: middle;">
                        {{ anexo.titulo || 'Sem título' }}
                      </span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="anexo-subtitle">
                      <span class="text-truncate d-block">{{ anexo.arquivo_nome }}</span>
                      <div v-if="anexo.tamanho_bytes || isPDF(anexo.arquivo_tipo)" class="mt-1">
                        <span v-if="anexo.tamanho_bytes">
                          {{ formatarTamanho(anexo.tamanho_bytes) }}
                        </span>
                        <v-chip
                            v-if="isPDF(anexo.arquivo_tipo)"
                            x-small
                            color="#e3f2fd"
                            text-color="#1565c0"
                            :class="anexo.tamanho_bytes ? 'ml-1' : ''"
                        >
                          <v-icon left x-small>mdi-eye</v-icon>
                          {{ isMobile ? 'Ver' : 'Visualizar' }}
                        </v-chip>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-menu offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            small
                            color="#023449"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                        >
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                            v-if="isPDF(anexo.arquivo_tipo)"
                            @click="visualizarAnexo(anexo)"
                        >
                          <v-list-item-icon>
                            <v-icon small color="primary">mdi-eye</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Visualizar</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="downloadAnexo(anexo)">
                          <v-list-item-icon>
                            <v-icon small color="success">mdi-download</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Download</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider></v-divider>

        <!-- Informações Básicas (expansível) -->
        <v-expansion-panels
            v-model="painelInfo"
            flat
            accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="section-header-inline" :class="isMobile ? 'pa-3' : 'pa-4'">
              <div class="d-flex align-center">
                <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-information</v-icon>
                <span class="section-title-inline">Informações Básicas</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div :class="isMobile ? 'pa-3' : 'pa-4'">
                <v-row :class="isMobile ? 'ma-0' : ''">
                  <v-col cols="12" :md="isMobile ? 12 : 6" :class="isMobile ? 'pa-2' : ''">
                    <div class="info-item mb-3">
                      <div class="info-label">Título</div>
                      <div class="info-value">{{ normativa.titulo }}</div>
                    </div>
                    <div class="info-item mb-3">
                      <div class="info-label">Código</div>
                      <div>
                        <v-chip :small="!isMobile" :x-small="isMobile" color="#023449" dark>
                          {{ normativa.codigo }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" :md="isMobile ? 12 : 6" :class="isMobile ? 'pa-2' : ''">
                    <div class="info-item mb-3">
                      <div class="info-label">Categorias</div>
                      <div class="d-flex flex-wrap align-start" style="gap: 6px;">
                        <CategoriaChip
                            v-for="categoria in normativa.categorias"
                            :key="categoria.id"
                            :categoria="categoria"
                            :size="isMobile ? 'x-small' : 'small'"
                        />
                        <span v-if="!normativa.categorias || normativa.categorias.length === 0" class="info-value">
                          -
                        </span>
                      </div>
                    </div>
                    <div class="info-item mb-3">
                      <div class="info-label">Status</div>
                      <div>
                        <v-chip
                            :small="!isMobile"
                            :x-small="isMobile"
                            :color="normativa.ativo === 'T' ? 'success' : 'grey'"
                            dark
                        >
                          <v-icon left :small="isMobile" :x-small="isMobile">
                            {{ normativa.ativo === 'T' ? 'mdi-check-circle' : 'mdi-cancel' }}
                          </v-icon>
                          {{ normativa.ativo === 'T' ? 'Ativa' : 'Inativa' }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                  <v-col v-if="normativa.descricao" cols="12" :class="isMobile ? 'pa-2' : ''">
                    <div class="info-item">
                      <div class="info-label">Descrição</div>
                      <div class="info-value description-text">{{ normativa.descricao }}</div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider></v-divider>

        <!-- Auditoria (expansível, recolhido por padrão) -->
        <v-expansion-panels
            v-model="painelAuditoria"
            flat
            accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="section-header-inline" :class="isMobile ? 'pa-3' : 'pa-4'">
              <div class="d-flex align-center">
                <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-calendar-clock</v-icon>
                <span class="section-title-inline">{{ isMobile ? 'Auditoria' : 'Informações de Auditoria' }}</span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div :class="isMobile ? 'pa-3' : 'pa-4'">
                <v-row :class="isMobile ? 'ma-0' : ''">
                  <v-col cols="12" :md="isMobile ? 12 : 6" :class="isMobile ? 'pa-2' : ''">
                    <div class="info-item mb-3">
                      <div class="info-label">Criada em</div>
                      <div class="info-value" :class="isMobile ? 'text-caption' : ''">
                        {{ formatarDataCompleta(normativa.data_criacao) }}
                      </div>
                    </div>
                    <div v-if="normativa.usuario_criacao" class="info-item">
                      <div class="info-label">Criada por</div>
                      <div>
                        <v-chip x-small color="#023449" outlined>
                          <v-icon left x-small>mdi-account</v-icon>
                          <span class="text-truncate" style="max-width: 150px;">
                            {{ normativa.usuario_criacao }}
                          </span>
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" :md="isMobile ? 12 : 6" :class="isMobile ? 'pa-2' : ''">
                    <div v-if="normativa.data_alteracao" class="info-item mb-3">
                      <div class="info-label">Última alteração</div>
                      <div class="info-value" :class="isMobile ? 'text-caption' : ''">
                        {{ formatarDataCompleta(normativa.data_alteracao) }}
                      </div>
                    </div>
                    <div v-if="normativa.usuario_alteracao" class="info-item">
                      <div class="info-label">Alterada por</div>
                      <div>
                        <v-chip x-small color="#023449" outlined>
                          <v-icon left x-small>mdi-account</v-icon>
                          <span class="text-truncate" style="max-width: 150px;">
                            {{ normativa.usuario_alteracao }}
                          </span>
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Ações -->
      <v-card-actions class="dialog-actions" :class="isMobile ? 'pa-3' : 'pa-4'">
        <v-spacer></v-spacer>

        <!-- Botão Editar (apenas admin) -->
        <v-btn
            v-if="permissao('normativa_admin')"
            color="#023449"
            outlined
            @click="$emit('editar', normativa)"
            :small="isMobile"
            :class="isMobile ? 'mr-1' : 'mr-2'"
        >
          <v-icon left :small="isMobile">mdi-pencil</v-icon>
          <span v-if="!isMobile">Editar</span>
        </v-btn>

        <v-btn
            color="#023449"
            dark
            @click="fechar"
            :small="isMobile"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog de Visualização de PDF -->
    <v-dialog
        v-model="dialogVisualizacaoPDF"
        :max-width="isMobile ? '100vw' : '1400px'"
        :fullscreen="isMobile"
        @click:outside="fecharVisualizacaoPDF"
    >
      <v-card v-if="pdfAtual">
        <v-card-title class="pdf-viewer-header white--text" :class="isMobile ? 'pa-3' : 'pa-4'">
          <v-icon color="red" :size="isMobile ? 20 : 24" class="mr-2">mdi-file-pdf-box</v-icon>
          <div class="flex-grow-1" style="min-width: 0;">
            <div :class="isMobile ? 'text-body-2' : 'text-subtitle-1'" class="font-weight-medium text-truncate">
              {{ pdfAtual.nome }}
            </div>
            <div class="text-caption grey--text text-truncate">
              {{ pdfAtual.tipo }}
            </div>
          </div>

          <!-- Botão Download -->
          <v-btn
              icon
              color="white"
              @click="downloadPDFAtual"
              :loading="baixandoPrincipal || baixandoAnexo"
              :small="isMobile"
              class="mr-1 flex-shrink-0"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-download</v-icon>
          </v-btn>

          <!-- Botão Fechar -->
          <v-btn
              icon
              @click="fecharVisualizacaoPDF"
              color="white"
              :small="isMobile"
              class="flex-shrink-0"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <div v-if="carregandoPDF" class="pdf-loading-container">
            <v-progress-circular
                indeterminate
                color="primary"
                :size="isMobile ? 48 : 64"
            ></v-progress-circular>
            <p class="mt-4" :class="isMobile ? 'text-body-2' : 'text-subtitle-1'">Carregando PDF...</p>
          </div>
          <iframe
              v-else-if="pdfAtual.url"
              :src="pdfAtual.url"
              class="pdf-viewer-iframe"
              frameborder="0"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
        bottom
        :multi-line="isMobile"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
            :small="isMobile"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import CategoriaChip from '../Widgets/CategoriaChip.vue'
import { mapState } from 'vuex'

export default {
  name: 'NormativaVisualizacao',

  components: {
    CategoriaChip
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    normativa: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogInterno: false,
      dialogVisualizacaoPDF: false,
      carregandoPDF: false,
      pdfAtual: null,
      windowWidth: window.innerWidth,

      baixandoPrincipal: false,
      baixandoAnexo: null,
      baixandoTodos: false,

      painelArquivo: 0,
      painelAnexos: 0,
      painelInfo: null,
      painelAuditoria: null,

      snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },

  computed: {
    ...mapState(["backendUrl"]),

    isMobile() {
      return this.windowWidth < 960
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    // Limpar URL do blob ao destruir o componente
    if (this.pdfAtual && this.pdfAtual.url) {
      window.URL.revokeObjectURL(this.pdfAtual.url)
    }

    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        this.dialogInterno = val

        if (val) {
          this.painelArquivo = 0
          this.painelAnexos = 0
          this.painelInfo = null
          this.painelAuditoria = null
        }
      }
    },

    dialogInterno(val) {
      if (!val) {
        this.$emit('update:dialog', false)
      }
    }
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },

    isPDF(tipo) {
      return tipo && tipo.toLowerCase() === 'pdf'
    },

    handleArquivoPrincipalClick() {
      this.visualizarArquivoPrincipal()
    },

    handleAnexoClick(anexo) {
      if (this.isPDF(anexo.arquivo_tipo)) {
        this.visualizarAnexo(anexo)
      } else {
        this.downloadAnexo(anexo)
      }
    },

    async visualizarArquivoPrincipal() {
      if (!this.normativa?.codigo) return

      this.carregandoPDF = true
      this.dialogVisualizacaoPDF = true

      try {
        const response = await axios.post(`${this.backendUrl}normativa/download`, {
          codigo: this.normativa.codigo,
          tipo_arquivo: 'principal'
        }, {
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const pdfParams = [
          'navpanes=1',
          'pagemode=thumbs',
          'page=1'
        ].join('&')

        this.pdfAtual = {
          nome: this.normativa.arquivo_nome || `${this.normativa.codigo}_normativa.pdf`,
          tipo: 'Arquivo Principal',
          url: `${url}#${pdfParams}`,
          blob: blob,
          codigo: this.normativa.codigo,
          tipoArquivo: 'principal'
        }

      } catch (error) {
        console.error('Erro ao visualizar PDF:', error)
        this.mostrarSnackbar('Erro ao carregar PDF para visualização', 'error')
        this.dialogVisualizacaoPDF = false
      } finally {
        this.carregandoPDF = false
      }
    },

    async visualizarAnexo(anexo) {
      if (!this.normativa?.codigo || !anexo?.identificador) return

      this.carregandoPDF = true
      this.dialogVisualizacaoPDF = true

      try {
        const response = await axios.post(`${this.backendUrl}normativa/download`, {
          codigo: this.normativa.codigo,
          tipo_arquivo: 'anexo',
          identificador: anexo.identificador
        }, {
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const pdfParams = [
          'navpanes=1',
          'pagemode=thumbs',
          'page=1'
        ].join('&')

        this.pdfAtual = {
          nome: anexo.arquivo_nome || `${this.normativa.codigo}_anexo_${anexo.identificador}.pdf`,
          tipo: `Anexo ${anexo.identificador}`,
          url: `${url}#${pdfParams}`,
          blob: blob,
          codigo: this.normativa.codigo,
          tipoArquivo: 'anexo',
          anexo: anexo
        }

      } catch (error) {
        console.error('Erro ao visualizar PDF:', error)
        this.mostrarSnackbar('Erro ao carregar PDF para visualização', 'error')
        this.dialogVisualizacaoPDF = false
      } finally {
        this.carregandoPDF = false
      }
    },

    fecharVisualizacaoPDF() {
      if (this.pdfAtual && this.pdfAtual.url) {
        window.URL.revokeObjectURL(this.pdfAtual.url)
      }
      this.dialogVisualizacaoPDF = false
      this.pdfAtual = null
    },

    downloadPDFAtual() {
      if (!this.pdfAtual) return

      if (this.pdfAtual.tipoArquivo === 'principal') {
        this.downloadArquivoPrincipal()
      } else if (this.pdfAtual.tipoArquivo === 'anexo' && this.pdfAtual.anexo) {
        this.downloadAnexo(this.pdfAtual.anexo)
      }
    },

    async downloadArquivoPrincipal() {
      if (!this.normativa?.codigo) return

      this.baixandoPrincipal = true

      try {
        const response = await axios.post(`${this.backendUrl}normativa/download`, {
          codigo: this.normativa.codigo,
          tipo_arquivo: 'principal'
        }, {
          responseType: 'blob'
        })

        const nomeArquivo = this.normativa.arquivo_nome || `${this.normativa.codigo}_normativa.pdf`

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nomeArquivo)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.mostrarSnackbar('Download concluído!', 'success')

      } catch (error) {
        console.error('Erro ao fazer download:', error)

        const mensagemErro = error.response?.data?.erro
            || error.message
            || 'Erro ao fazer download do arquivo'

        this.mostrarSnackbar(mensagemErro, 'error')
      } finally {
        this.baixandoPrincipal = false
      }
    },

    async downloadAnexo(anexo) {
      if (!this.normativa?.codigo || !anexo?.identificador) return

      this.baixandoAnexo = anexo.identificador

      try {
        const response = await axios.post(`${this.backendUrl}normativa/download`, {
          codigo: this.normativa.codigo,
          tipo_arquivo: 'anexo',
          identificador: anexo.identificador
        }, {
          responseType: 'blob'
        })

        const nomeArquivo = anexo.arquivo_nome || `${this.normativa.codigo}_anexo_${anexo.identificador}.pdf`

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nomeArquivo)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.mostrarSnackbar('Download concluído!', 'success')

      } catch (error) {
        console.error('Erro ao fazer download:', error)

        const mensagemErro = error.response?.data?.erro
            || error.message
            || 'Erro ao fazer download do anexo'

        this.mostrarSnackbar(mensagemErro, 'error')
      } finally {
        this.baixandoAnexo = null
      }
    },

    async downloadTodos() {
      this.baixandoTodos = true

      try {
        await this.downloadArquivoPrincipal()

        if (this.normativa.anexos && this.normativa.anexos.length > 0) {
          for (const anexo of this.normativa.anexos) {
            await new Promise(resolve => setTimeout(resolve, 500))
            await this.downloadAnexo(anexo)
          }
        }

        this.mostrarSnackbar('Todos os arquivos foram baixados!', 'success')

      } catch (error) {
        console.error('Erro ao baixar todos os arquivos:', error)
        this.mostrarSnackbar('Erro ao baixar alguns arquivos', 'error')
      } finally {
        this.baixandoTodos = false
      }
    },

    getIconeTipo(tipo) {
      const icones = {
        'pdf': 'mdi-file-pdf-box',
        'doc': 'mdi-file-word-box',
        'docx': 'mdi-file-word-box',
        'xls': 'mdi-file-excel-box',
        'xlsx': 'mdi-file-excel-box'
      }
      return icones[tipo] || 'mdi-file-document'
    },

    getCorTipo(tipo) {
      const cores = {
        'pdf': 'red',
        'doc': 'blue',
        'docx': 'blue',
        'xls': 'green',
        'xlsx': 'green'
      }
      return cores[tipo] || 'grey'
    },

    formatarTamanho(bytes) {
      if (!bytes || bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },

    formatarDataCompleta(dataString) {
      if (!dataString) return '-'

      try {
        const partes = dataString.split('-')

        if (partes.length >= 4) {
          const ano = partes[0]
          const mes = partes[1]
          const dia = partes[2]

          const horaCompleta = partes[3]
          const partesHora = horaCompleta.split('.')

          const hora = partesHora[0] || '00'
          const minuto = partesHora[1] || '00'

          const data = new Date(ano, mes - 1, dia, hora, minuto)

          return data.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        }

        return '-'
      } catch (error) {
        console.error('Erro ao formatar data:', error, dataString)
        return '-'
      }
    },

    fechar() {
      this.dialogInterno = false
      this.$emit('fechar')
    },

    mostrarSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    }
  }
}
</script>

<style scoped>
.visualization-dialog {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Dialog Header */
.dialog-header {
  background: linear-gradient(135deg, #023449 0%, #034d6b 100%);
  color: white;
}

.icon-wrapper-large {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  line-height: 1.3;
  margin-bottom: 6px;
}

.header-subtitle {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-subtitle-mobile {
  display: flex;
  align-items: center;
}

/* Dialog Content */
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}

/* Expansion Panels */
::v-deep .v-expansion-panel {
  background: white !important;
}

::v-deep .v-expansion-panel::before {
  box-shadow: none !important;
}

::v-deep .v-expansion-panel-header {
  min-height: 56px !important;
  padding: 16px !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.section-header-inline {
  background-color: #fafafa !important;
  display: flex;
  align-items: center;
}

.section-title-inline {
  font-size: 1rem;
  font-weight: 700;
  color: #023449;
  letter-spacing: -0.01em;
}

/* Info Items */
.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 0.813rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 0.938rem;
  color: #1e293b;
  font-weight: 500;
}

.description-text {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid #023449;
}

/* File Card */
.file-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.file-card:hover {
  border-color: #023449;
  box-shadow: 0 4px 12px rgba(2, 52, 73, 0.1);
}

.file-icon-wrapper {
  background: #fef2f2;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-icon-wrapper-small {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-name {
  font-size: 0.938rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.file-type {
  font-size: 0.813rem;
  color: #64748b;
  display: flex;
  align-items: center;
}

/* Anexos */
.anexo-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  margin: 4px 8px;
}

.anexo-item:hover {
  background-color: rgba(2, 52, 73, 0.04);
}

.anexo-title {
  font-size: 0.938rem;
  font-weight: 600;
  color: #1e293b;
}

.anexo-subtitle {
  font-size: 0.813rem;
  color: #64748b;
}

/* Previne scroll duplo em diálogos */
::v-deep .v-dialog--active {
  overflow-y: hidden !important;
}

/* Garante que apenas o conteúdo do diálogo tenha scroll quando necessário */
::v-deep .v-dialog--active .v-card {
  overflow: visible;
}

/* O iframe do PDF deve gerenciar seu próprio scroll */
.pdf-viewer-iframe {
  width: 100%;
  height: calc(100vh - 200px);
  min-height: 600px;
  background-color: #525659;
  overflow: auto;
}

/* Remove scroll da área de loading */
.pdf-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
  background-color: #f5f5f5;
  overflow: hidden;
  padding: 20px;
}

/* PDF Viewer Dialog */
.pdf-viewer-header {
  background: rgba(2, 52, 73, 0.9);
  border-bottom: 1px solid whitesmoke;
}

/* Dialog Actions */
.dialog-actions {
  background-color: #fafafa;
}

.cursor-pointer {
  cursor: pointer;
}

/* Scrollbar customizada */
.dialog-content::-webkit-scrollbar {
  width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Mobile Styles */
@media (max-width: 959px) {
  .header-title {
    font-size: 1rem;
  }

  .icon-wrapper-large {
    padding: 10px;
    border-radius: 8px;
  }

  .section-title-inline {
    font-size: 0.875rem;
  }

  .pdf-viewer-iframe {
    height: calc(100vh - 120px);
    min-height: auto;
  }

  .pdf-loading-container {
    height: calc(100vh - 120px);
    min-height: 400px;
  }

  .dialog-content {
    max-height: calc(100vh - 180px);
  }

  .file-icon-wrapper {
    padding: 8px;
  }

  .file-name {
    font-size: 0.875rem;
  }

  .file-type {
    font-size: 0.75rem;
  }

  .anexo-title {
    font-size: 0.875rem;
  }

  .anexo-subtitle {
    font-size: 0.75rem;
  }

  .info-label {
    font-size: 0.75rem;
  }

  .info-value {
    font-size: 0.875rem;
  }

  .description-text {
    padding: 8px;
    font-size: 0.875rem;
  }
}

/* Tablets */
@media (max-width: 768px) and (min-width: 600px) {
  .header-title {
    font-size: 1.125rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .file-card,
  .anexo-item {
    transition: none !important;
  }
}
</style>